module.exports = __webpack_public_path__ + "img/zhuanpan.07dbe668.png";